import React from 'react'
import { connect } from 'react-redux'
import GenericModal from 'app/views/components/Modals/GenericModal'
import Icon from 'app/views/components/Icon'
import settings from 'settings'

import {
  setNoTraining,
  setOrganizationDefaultPlan,
  activateAutomatedPlan,
  setDefaultPlan,
} from 'app/state/modules/plan'

class PlanChangeModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 0,
    }
    this.modal = React.createRef()
    this.show = this.show.bind(this)
    this.changePage = this.changePage.bind(this)
    this.hide = this.hide.bind(this)
    if (this.props.onRef) {
      this.props.onRef(this)
    }
  }

  show() {
    this.setState({
      page: 0,
    }, () => {
      this.modal.current.show()
    })
  }

  hide() {
    this.modal.current.hide()
  }

  changePage(e) {
    this.setState({
      page: parseInt(e.target.dataset.page, 10),
    })
  }

  renderStepOne() {
    return (
      <>
        <div className="uk-flex uk-flex-column uk-flex-stretch uk-flex center">
          <button
            onClick={this.changePage}
            type="button"
            className="uk-button uk-button-small uk-button-secondary uk-position-absolute uk-flex uk-flex-middle"
            data-page="0"
            style={{
              top: 20,
              leftuse: 15,
              display: 'none',
            }}
          >
            <Icon name="arrow-left" className="uk-margin-small-right" />
            Back
          </button>
          <button
            type="button"
            className="uk-button uk-button-default uk-margin-top uk-flex uk-flex-middle uk-flex-center uk-position-relative"
            onClick={() => {
              this.hide()
              this.props.activateAutomatedPlan(
                this.props.organizationUUID,
                this.props.teamUUID,
                this.props.onRefresh,
              )
            }}
          >
            <Icon
              name="user-settings"
              className="uk-margin-small-right uk-position-absolute"
              style={{
                left: 17.5,
              }}
            />
            Use Adaptive Training Plan
          </button>
          <button
            type="button"
            data-page="1"
            onClick={this.changePage}
            className="uk-button uk-button-default uk-margin-top uk-flex uk-flex-middle uk-flex-center uk-position-relative"
          >
            <Icon
              name="list-check-2"
              none
              className="uk-margin-small-right uk-position-absolute"
              style={{
                left: 17.5,
              }}
            />
            Use Custom Plan
          </button>
          {(this.props.teamUUID) && (
            <button
              type="button"
              className="uk-button uk-button-default uk-margin-top uk-flex uk-flex-middle uk-flex-center uk-position-relative"
              onClick={() => {
                this.hide()
                this.props.setOrganizationDefaultPlan(
                  this.props.organizationUUID,
                  this.props.teamUUID,
                  this.props.onRefresh,
                )
              }}
            >
              <Icon
                name="building-2"
                className="uk-margin-small-right uk-position-absolute"
                style={{
                  left: 17.5,
                }}
              />
             Use Organization Default
            </button>
          )}
          <button
            onClick={() => {
              this.hide()
              this.props.setNoTraining(
                this.props.organizationUUID,
                this.props.teamUUID,
                this.props.onRefresh,
              )
            }}
            type="button"
            className="uk-button uk-button-default uk-margin-top uk-flex uk-flex-middle uk-flex-center uk-position-relative"
          >
            <Icon
              name="user-unfollow"
              className="uk-margin-small-right uk-position-absolute"
              style={{
                left: 17.5,
              }}
            />
              No Training
          </button>
          <br />
          <hr />
          <p className="uk-text-center">
            <i>
              Or select one of HackEDU's preset plans:
            </i>
          </p>
          {((settings || {}).plans || []).map((plan, index) => (
            <button
              onClick={() => {
                this.hide()
                this.props.history.push({
                  pathname: `/admin/${this.props.organizationUUID}/plans/add${this.props.teamUUID ? '/team' : ''}`,
                  state: {
                    planUUIDClone: plan.uuid,
                    defaultTeamUUID: this.props.teamUUID,
                    planTitle: plan.title,
                    planDescription: plan.description,
                  },
                })
              }}
              className={`uk-flex uk-flex-middle uk-flex-center uk-position-relative uk-button uk-button-secondary${index > 0 ? ' uk-margin-top' : ''}`}
              type="button"
              key={plan.uuid}
            >
              <Icon
                name="list-check-2"
                none
                className="uk-margin-small-right uk-position-absolute"
                style={{
                  left: 17.5,
                }}
              />
              {plan.title}
            </button>
          ))}
        </div>
      </>
    )
  }

  renderPlansToClone() {
    return (
      <>
        <div className="uk-flex uk-flex-column uk-flex-stretch uk-flex center">
          <button
            onClick={this.changePage}
            type="button"
            className="uk-button uk-button-small uk-button-secondary uk-position-absolute uk-flex uk-flex-middle"
            data-page="1"
            style={{
              top: 20,
              left: 15,
            }}
          >
            <Icon name="arrow-left" className="uk-margin-small-right" />
            Back
          </button>
          <h3>Organization plans</h3>
          {this.props.clonePlanList.filter((p) => !p.team).map((plan) => {
            return (
              <button
                key={plan.uuid}
                onClick={() => {
                  this.hide()
                  this.props.history.push({
                    pathname: `/admin/${this.props.organizationUUID}/plans/add${this.props.teamUUID ? '/team' : ''}`,
                    state: {
                      planUUIDClone: plan.uuid,
                      defaultTeamUUID: this.props.teamUUID,
                      planTitle: plan.title,
                      planDescription: plan.description,
                    },
                  })
                }}
                type="button"
                className={`uk-button ${plan.team ? 'uk-button-default' : 'uk-button-secondary'} uk-margin-top uk-flex uk-flex-middle uk-flex-center uk-position-relative`}
              >
                <Icon
                  name="file-copy-2"
                  fill
                  className="uk-margin-small-right uk-position-absolute"
                  style={{
                    left: 17.5,
                  }}
                />
                <div className="uk-text-truncate uk-margin-large-left uk-margin-large-right">
                  {plan.title}
                </div>
              </button>
            )
          })}
          <h3>Team plans</h3>
          {this.props.clonePlanList.filter((p) => p.team).length === 0 && (
            <p className="uk-text-center">
              No team plans.
            </p>
          )}
          {this.props.clonePlanList.filter((p) => p.team).map((plan) => {
            return (
              <button
                key={plan.uuid}
                onClick={() => {
                  this.hide()
                  this.props.history.push({
                    pathname: `/admin/${this.props.organizationUUID}/plans/add${this.props.teamUUID ? '/team' : ''}`,
                    state: {
                      planUUIDClone: plan.uuid,
                      defaultTeamUUID: this.props.teamUUID,
                      planTitle: plan.title,
                      planDescription: plan.description,
                    },
                  })
                }}
                type="button"
                className={`uk-button ${plan.team ? 'uk-button-default' : 'uk-button-secondary'} uk-margin-top uk-flex uk-flex-middle uk-flex-center uk-position-relative`}
              >
                <Icon
                  name="file-copy-2"
                  fill
                  className="uk-margin-small-right uk-position-absolute"
                  style={{
                    left: 17.5,
                  }}
                />
                <div className="uk-text-truncate uk-margin-large-left uk-margin-large-right">
                  {`${plan.team.name}: ${plan.title}`}
                </div>
              </button>
            )
          })}
        </div>
      </>
    )
  }

  renderCustomizePlan() {
    const unUsedPlans = (this.props.clonePlanList.filter((plan) => (
      this.props.teamUUID ? plan.team_uuid === this.props.teamUUID : !plan.team_uuid
        && !plan.is_default
        && plan.is_custom_plan
    )) || [])
    return (
      <>
        <div className="uk-flex uk-flex-column uk-flex-stretch uk-flex center">
          <button
            onClick={this.changePage}
            type="button"
            className="uk-button uk-button-small uk-button-secondary uk-position-absolute uk-flex uk-flex-middle"
            data-page="0"
            style={{
              top: 20,
              left: 15,
            }}
          >
            <Icon name="arrow-left" className="uk-margin-small-right" />
            Back
          </button>
          {this.props.planToEdit && (
            <button
              type="button"
              onClick={() => {
                this.hide()
                this.props.history.push(`/admin/${this.props.organizationUUID}/plans/${this.props.planToEdit}`)
              }}
              className="uk-button uk-button-default uk-margin-top uk-flex uk-flex-middle uk-flex-center uk-position-relative"
            >
              <Icon
                name="edit-circle"
                fill
                className="uk-margin-small-right uk-position-absolute"
                style={{
                  left: 17.5,
                }}
              />
              Edit the current plan
            </button>
          )}
          <button
            type="button"
            onClick={() => {
              this.hide()
              this.props.history.push({
                pathname: `/admin/${this.props.organizationUUID}/plans/add${this.props.teamUUID ? '/team' : ''}`,
                state: {
                  defaultTeamUUID: this.props.teamUUID ? this.props.teamUUID : undefined,
                },
              })
            }}
            className="uk-button uk-button-default uk-margin-top uk-flex uk-flex-middle uk-flex-center uk-position-relative"
          >
            <Icon
              name="add-circle"
              fill
              className="uk-margin-small-right uk-position-absolute"
              style={{
                left: 17.5,
              }}
            />
            Start from Scratch
          </button>
          <button
            onClick={() => {
              this.setState({
                page: 2,
              })
            }}
            type="button"
            className="uk-button uk-button-default uk-margin-top uk-flex uk-flex-middle uk-flex-center uk-position-relative"
          >
            <Icon
              name="file-copy-2"
              fill
              className="uk-margin-small-right uk-position-absolute"
              style={{
                left: 17.5,
              }}
            />
             Clone an Existing Plan
          </button>
          {unUsedPlans.length > 0 && (
            <>
              <hr />
              <p className="uk-text-center">
                <i>
                  Or select one of your unused plans:
                </i>
              </p>
              {
                unUsedPlans.map((p) => (
                  <button
                    type="button"
                    className="uk-button uk-button-secondary uk-margin-bottom uk-flex uk-flex-middle uk-flex-center uk-position-relative"
                    key={p.uuid}
                    onClick={() => {
                      this.props.setDefaultPlan(
                        p.uuid,
                        this.props.organizationUUID,
                        this.props.teamUUID,
                        () => {
                          this.hide()
                          if (typeof this.props.onRefresh === 'function') {
                            this.props.onRefresh()
                          }
                        },
                      )
                    }}
                  >
                    <Icon
                      name="list-check-2"
                      none
                      className="uk-margin-small-right uk-position-absolute"
                      style={{
                        left: 17.5,
                      }}
                    />
                    {p.title}
                  </button>
                ))}
            </>
          )}
        </div>
      </>
    )
  }

  renderPages() {
    switch (this.state.page) {
      case 1:
        return this.renderCustomizePlan()
      case 2:
        return this.renderPlansToClone()
      default:
        return this.renderStepOne()
    }
  }

  renderTitles() {
    switch (this.state.page) {
      case 1:
        return 'Customize a Plan'
      default:
        return 'Change Plan'
    }
  }

  render() {
    return (
      <GenericModal
        ref={this.modal}
        id={this.props.id || 'change-plan-modal'}
        title={this.renderTitles()}
        titleClassName="uk-text-center"
        body={(
          this.renderPages()
        )}
      />
    )
  }
}

const mapStateToProps = ({ plan }) => ({
  clonePlanList: plan.clonePlanList,
})

export default connect(mapStateToProps, {
  setNoTraining,
  activateAutomatedPlan,
  setDefaultPlan,
  setOrganizationDefaultPlan,
}, null)(PlanChangeModal)
